import React, { useEffect, useState } from 'react';
import PageHeading from '../../../components/PageHeading';
import PurchaseOrderPopUp from './PurchaseOrderPopUp';
import GetPurchaseOrder from '../../../APIs/Vendor/GetPurchaseOrder';
import SideMessage from '../../../components/SideMessage';
import DeletePurchaseOrder from '../../../APIs/Vendor/DeletePurchaseOrder';
import Loader from '../../../components/Loader';
import { useNavigate } from 'react-router-dom';
import FilterTable from '../../../components/FilterTable';

const PurchaseOrder = () => {
    const [showModal, setShowModal] = useState(0)
    // const [rowId, setRowId] = useState(0)
    // const [isShowDeleteModel, setIsShowDeleteModel] = useState(0)
    const [purchaseOrderList, setPurchaseOrderList] = useState([])
    const [purchaseOrderTempList, setPurchaseOrderTempList] = useState([])
    // const [editData, setEditData] = useState([])
    // const [isEdit, setIsEdit] = useState(0)
    const navigate = useNavigate();
    const [isShowLoader, setIsShowLoader] = useState(0)
    const [sideToster, setSideToster] = useState({
        show: 0,
        message: '',
        type: ''
    })
    const getPurchaseOrder = async () => {
        try {
            setIsShowLoader(1);
            let purchaseorder = await GetPurchaseOrder()
            if (purchaseorder.status === 1) {
                setIsShowLoader(0);
                setPurchaseOrderList(purchaseorder.responseValue)
            }
            else {
                setSideToster({
                    message: purchaseorder.responseValue,
                    show: 1,
                    type: 'alert'
                })
                setIsShowLoader(0);
            }
        }
        catch (e) {
            setSideToster({
                message: e.message,
                show: 1,
                type: 'alert'
            })
            setIsShowLoader(0);
        }

    }
    const handleUpdate = (val) => {
        navigate("/addpurchaseorder/" + val.id)
        // setEditData(val)
        // setIsEdit(1)
        // setShowModal(1)
    }

    let handleDelete = async (rowId) => {
        setIsShowLoader(1);
        const response = await DeletePurchaseOrder(rowId);
        if (response.status === 1) {
            setIsShowLoader(0);
            // setIsShowDeleteModel(0);
            setSideToster({
                message: 'Data Deleted',
                show: 1,
                type: 'Success'
            })
            getPurchaseOrder();
        }
        else {
            setIsShowLoader(0);
            setSideToster({
                show: 1,
                message: response.responseValue,
                type: 'Alert'
            })
        }
    }

    useEffect(() => {
        if (showModal === 0) {
            getPurchaseOrder();
        }
    }, [showModal])

    return (
        <div className='row pb-3 container-fluid  p-4'>


            <div className="container-fluid landformconatiner p-4">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <PageHeading pagename="Purchase Order" />
                    <button className="bg-#00AFF0" type="button" class="btn btn-primary" onClick={() => { navigate("/addpurchaseorder/") }}>+ Add Purchase Order</button>
                </div>
            </div>

            <div className="container-fluid landformconatiner p-4 mt-3">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <PageHeading pagename="Purchase List" />
                    <FilterTable tempList={purchaseOrderTempList} tempListMethod={setPurchaseOrderTempList} originalList={purchaseOrderList} isSearch={true} isdate={false} isFilter={false} isExport={true} />
                </div>
                <table class="table">
                    <thead>
                        <tr className='table-head'>
                            {/* <th scope="col">S.No.</th> */}
                            <th scope="col">Expense Type</th>
                            <th scope="col">Vendor</th>
                            <th scope="col">Item Name</th>
                            <th scope="col">Quantity</th>
                            <th scope="col">Unit</th>
                            <th scope="col">Price</th>
                            <th scope="col">ACTION</th>
                        </tr>
                    </thead>
                    <tbody className='table-body'>
                        {
                            purchaseOrderTempList && purchaseOrderTempList.map((val, ind) => {
                                return (
                                    <tr  key={val.id} style={{ cursor: "pointer" }}>
                                        {/* <td>{ind + 1}</td> */}
                                        <td>{val.expenseName}</td>
                                        <td>{val.vendorName}</td>
                                        <td>{val.itemName}</td>
                                        <td>{val.quantity}</td>
                                        <td>{val.unit}</td>
                                        <td>{val.price}</td>
                                        <td>
                                            <div class="dropdown dropend">
                                                <i class="bi bi-three-dots-vertical " data-bs-toggle="dropdown" aria-expanded="false"></i>
                                                <ul className="dropdown-menu mr-3">
                                                    <li>
                                                        <span className="dropdown-item" onClick={() => { handleUpdate(val) }}>Edit</span>
                                                    </li>
                                                    <li>
                                                        <span className="dropdown-item" onClick={() => { handleDelete(val.id); }}>Delete</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>

            </div>
            {/* {
                showModal ? <PurchaseOrderPopUp showModal={showModal} closeModal={setShowModal} editData={editData} setEditData={setEditData} isEdit={isEdit} setIsEdit={setIsEdit} /> : ""
            } */}
            {
                sideToster.show === 1 ?
                    <SideMessage close={setSideToster} show={sideToster.show} type={sideToster.type} message={sideToster.message} />
                    : ""
            }
            {
                <Loader show={isShowLoader} />
            }
        </div>
    );
};

export default PurchaseOrder;